// Single source of truth for EZ Device business data.
// Update this file to change phone / address / hours / socials sitewide.

export const SITE = {
  name: "EZ Device",
  tagline: "We make it eazy",
  description: "Buy · Sell · Trade · Service",

  // Contact
  phoneDisplay: "+62 888-888-1868",
  phoneTel: "+628888881868",
  whatsappNumber: "628888881868", // wa.me format (no +, no spaces)
  email: "ezdevicecontact@gmail.com",

  // Address
  addressShort: "Jakarta, Indonesia",
  addressLines: [
    "EZ Device · Jakarta",
    "Indonesia · Tap for directions",
  ],
  googleMapsShareUrl: "https://share.google/pirU3B0qVSmPAmjLY",
  // Official Google Maps embed iframe (place: EZ Device, Jakarta)
  googleMapsEmbedSrc:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.3047124842806!2d106.82329991240324!3d-6.223493293738566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f303a3a08fd5%3A0xea9d102ce139c04d!2sEZ%20Device!5e0!3m2!1sen!2sid!4v1778731564728!5m2!1sen!2sid",

  // Hours
  hours: [
    { day: "Monday – Sunday", time: "10:30 – 20:00" },
    { day: "Public holidays", time: "Open · same hours" },
  ],
  openLabel: "Open Today · 10:30–20:00",

  // Socials
  socials: {
    instagram: "https://www.instagram.com/ezdevice.id/",
  },

  // Pre-filled WhatsApp messages
  waMessages: {
    general: "Hi EZ Device, I'd like help with",
    bookRepair: "Hi EZ Device, I'd like to book a repair",
    tradeIn: "Hi EZ Device, I'd like a trade-in quote for",
  },
};

// Helpers
export const waLink = (msg = SITE.waMessages.general) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(msg)}`;
